import { Modal, Stack, Text, Group, Button, Alert, ThemeIcon } from '@mantine/core';
import { AlertTriangle, ArrowRight } from 'react-feather';

export interface GroupReassignInfo {
  participantName: string;
  participantUserId: string;
  currentGroupName: string | null;
  currentCoachName: string | null;
  newGroupName: string;
  newCoachName: string | null;
  newGroupId: string;
}

interface GroupReassignConfirmModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  info: GroupReassignInfo | null;
  confirming?: boolean;
}

export function GroupReassignConfirmModal({
  opened,
  onClose,
  onConfirm,
  info,
  confirming = false,
}: GroupReassignConfirmModalProps) {
  if (!info) return null;

  const isNewAssignment = !info.currentGroupName;

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Confirm Group Assignment"
      size="sm"
    >
      <Stack gap="md">
        <Text size="sm">
          {isNewAssignment ? (
            <>Assign <strong>{info.participantName}</strong> to <strong>{info.newGroupName}</strong>?</>
          ) : (
            <>Move <strong>{info.participantName}</strong> from <strong>{info.currentGroupName}</strong> to <strong>{info.newGroupName}</strong>?</>
          )}
        </Text>

        <Alert
          icon={<AlertTriangle size={16} />}
          color="warningAmber"
          variant="light"
          title="1:1 Coach Assignment Will Change"
        >
          <Stack gap="xs">
            <Text size="sm">
              This participant&apos;s 1:1 coach will also be updated to match the new group&apos;s coach.
            </Text>

            <Group gap="xs" align="center" wrap="nowrap">
              <Stack gap={2} style={{ flex: 1 }}>
                <Text size="xs" c="dimmed">Current Coach</Text>
                <Text size="sm" fw={500}>
                  {info.currentCoachName || 'Unassigned'}
                </Text>
              </Stack>

              <ThemeIcon size="sm" variant="transparent" c="dimmed">
                <ArrowRight size={14} />
              </ThemeIcon>

              <Stack gap={2} style={{ flex: 1 }}>
                <Text size="xs" c="dimmed">New Coach</Text>
                <Text size="sm" fw={500}>
                  {info.newCoachName || 'Unassigned'}
                </Text>
              </Stack>
            </Group>
          </Stack>
        </Alert>

        <Group justify="flex-end" gap="sm" mt="sm">
          <Button variant="default" onClick={onClose} disabled={confirming}>
            Cancel
          </Button>
          <Button onClick={onConfirm} loading={confirming}>
            Confirm
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}

export default GroupReassignConfirmModal;
